module.exports = __webpack_public_path__ + "img/app.svg";